import { ReactComponent as Whatsapp } from '~/assets/svg/whatsapp.svg';
import { ReactComponent as Shopify } from '~/assets/svg/shopify.svg';
import { ReactComponent as FaceAgent } from '~/assets/svg/face_agent.svg';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslateButton } from '~/components/shared/TranslateButton';

interface PresentationSlideProps {
  submitForm: boolean;
  moveNextStep: () => void;
}

export const PresentationSlide = ({
  submitForm,
  moveNextStep,
}: PresentationSlideProps) => {
  const { t } = useTranslation('onboarding');

  useEffect(() => {
    if (submitForm) {
      moveNextStep();
    }
  }, [submitForm]);

  return (
    <div className="flex flex-col gap-8" data-testid="presentation-slide">
      <h1 className="text-3xl font-bold">{t('presentation_slide.title')}</h1>
      <div className="w-40">
        <TranslateButton updateOwnerOnChange />
      </div>
      <p className="text-md mt-3">{t('presentation_slide.description')}</p>
      <div className="flex flex-col gap-8 rounded-lg border border-custom-surface-400 bg-base-100 p-5 md:p-10">
        <div className="flex flex-row gap-6">
          <Whatsapp className="h-6 w-6 text-current" />
          <p>
            <strong className="mr-1">
              {t('presentation_slide.whatsapp_bold')}
            </strong>
            {t('presentation_slide.whatsapp')}
          </p>
        </div>
        <div className="flex flex-row gap-6">
          <Shopify className="h-6 w-6 text-current" />
          <p>
            <strong className="mr-1">
              {t('presentation_slide.shopify_bold')}
            </strong>
            {t('presentation_slide.shopify')}
          </p>
        </div>
        <div className="flex flex-row gap-6">
          <FaceAgent className="h-6 w-6 text-current" />
          <p>
            <strong className="mr-1">
              {t('presentation_slide.train_bold')}
            </strong>
            {t('presentation_slide.train')}
          </p>
        </div>
      </div>
      <p>{t('presentation_slide.footer')}</p>
    </div>
  );
};
